import { useEffect } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../utils/firebase"; // Adjust based on your project

const AUTO_LOGOUT_TIME = 15 * 60 * 1000; // 15 minutes in milliseconds

const useAutoLogout = () => {
  useEffect(() => {
    let logoutTimer;

    const resetTimer = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(() => {
        signOut(auth).then(() => {
          console.log("✅ User automatically logged out due to inactivity");
          window.location.reload(); // Refresh the app to reflect the logout
        }).catch(error => console.error("🔥 Auto logout error:", error));
      }, AUTO_LOGOUT_TIME);
    };

    // Listen for user interactions
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);

    resetTimer(); // Initialize timer on mount

    return () => {
      clearTimeout(logoutTimer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
    };
  }, []);
};

export default useAutoLogout;